/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import conflictManagement from '../../../assets/itpmetrics/conflict-management-img.png';
import entEffectiveness from '../../../assets/itpmetrics/ent-effectiveness-img.png';
import peer from '../../../assets/itpmetrics/peer-feedback-img.png';
import personality from '../../../assets/itpmetrics/personality-img.png';
import leadership from '../../../assets/itpmetrics/set-img.png';
import team from '../../../assets/itpmetrics/team-health-img.png';
import { __ } from '../../../helpers/translations';
import Section from '../../common/Section';

import CardService from './CardService';
import SectionHeader from './SectionHeader';

export const reviews = [
  [
    {
      title: __('G40'),
      type: __('G176'),
      description: __('G41'),
      image: peer,
    },
  ],
];

export const categorizedServices = [
  {
    heading: __('G277'),
    surveys: [
      {
        title: __('G22'),
        id: 'teamPlayer',
        description: __('G23'),
        image: peer,
        type: __('G170'),
        alternate: {
          title: __('G24'),
          id: 'teamPlayerFacets',
          description: __('G25'),
          type: __('G170'),
        },
      },
      {
        title: __('G26'),
        id: 'entEffectiveness',
        description: __('G27'),
        image: entEffectiveness,
        type: __('G170'),
      },
      {
        title: __('G280'),
        id: 'peerFeedback',
        description: __('G29'),
        image: peer,
        type: __('G170'),
      },
    ],
  },
  {
    heading: __('G278'),
    surveys: [
      {
        title: __('G30'),
        id: 'teamDynamics',
        description: __('G31'),
        image: team,
        type: __('G171'),
      },
    ],
  },
  {
    heading: __('G295'),
    surveys: [
      {
        title: __('G330'),
        id: 'peerFeedbackTeamDynamics',
        description: __('G33'),
        image: team,
        type: __('G275'),
      },
      {
        title: __('G276'),
        id: 'entEffectivenessTeamDynamics',
        description: __('G27'),
        image: entEffectiveness,
        type: __('G275'),
      },
      {
        title: __('G297'),
        id: 'teamPlayerTeamDynamics',
        description: __('G33'),
        image: team,
        type: __('G275'),
        alternate: {
          title: __('G340'),
          id: 'teamPlayerFacetsTeamDynamics',
          description: __('G25'),
          type: __('G170'),
        },
      },
      {
        title: `${__('G297')} 2026`,
        id: 'teamPlayerTeamDynamics2026',
        description: __('G33'),
        image: team,
        type: __('G275'),
        alternate: {
          title: `${__('G340')} 2026`,
          id: 'teamPlayerFacetsTeamDynamics2026',
          description: __('G25'),
          type: __('G170'),
        },
      },
    ],
  },
  {
    heading: __('G279'),
    surveys: [
      {
        title: __('G34'),
        id: 'personality',
        description: __('G35'),
        image: personality,
        type: __('G172'),
        alternate: {
          self: true,
          id: 'personality',
          description: __('G303'),
        },
      },
      {
        title: __('G36'),
        id: 'conflictManagement',
        description: __('G37'),
        image: conflictManagement,
        type: __('G172'),
        alternate: {
          self: true,
          id: 'conflictManagement',
          description: __('G303'),
        },
      },
    ],
  },
  {
    heading: __('G334'),
    surveys: [
      {
        title: __('G333'),
        id: 'leadership',
        description: __('G332'),
        image: leadership,
        type: __('G335'),
      },
    ],
  },
];

function Services() {
  const isExceptionIndex = (index, list) => index === list.length - 1 && index % 2 === 0 && index !== 0;

  return (
    <Section bg="light" className="text-center" style={{ paddingTop: '1em' }}>
      {categorizedServices.map((categorizedService, index) => (
        <div key={`service-${index}`} style={{ paddingTop: '3em' }}>
          <SectionHeader
            key={`service-header-${index}`}
            title={categorizedService.heading}
            subtitle=""
          />

          <Row className="mt-6 g-6 justify-content-md-center" key={`service-${index}`}>
            {categorizedService.surveys.map((service, j) => (
              <Col
                lg={6}
                className="mt-lg-6"
                key={`service-${index}-${j}`}
                style={isExceptionIndex(j, categorizedService.surveys) ? { paddingTop: '6em' } : {}}
              >
                <CardService {...service} />
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </Section>
  );
}

export default Services;
